"use client";
import { getDefaultZIndex } from "../../core/utils/get-default-z-index/get-default-z-index.mjs";
import { createContext, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Modal/ModalStack.tsx
const ModalStackContext = createContext(null);
function ModalStack({ children }) {
	const [stack, setStack] = useState([]);
	const [maxZIndex, setMaxZIndex] = useState(getDefaultZIndex("modal"));
	return /* @__PURE__ */ jsx(ModalStackContext, {
		value: {
			stack,
			addModal: (id, zIndex) => {
				setStack((current) => [.../* @__PURE__ */ new Set([...current, id])]);
				setMaxZIndex((current) => typeof zIndex === "number" && typeof current === "number" ? Math.max(current, zIndex) : current);
			},
			removeModal: (id) => setStack((current) => current.filter((currentId) => currentId !== id)),
			getZIndex: (id) => `calc(${maxZIndex} + ${stack.indexOf(id)} + 1)`,
			currentId: stack[stack.length - 1],
			maxZIndex
		},
		children
	});
}
ModalStack.displayName = "@mantine/core/ModalStack";
//#endregion
export { ModalStack, ModalStackContext };

//# sourceMappingURL=ModalStack.mjs.map